module.exports = __webpack_public_path__ + "static/media/ii12.5f404ce5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/igor by igor/ii12.jpg
// module id = 513
// module chunks = 0